import { Directive } from '@angular/core';
// libs
import { BaseComponent } from '@macs-frontend/core';

@Directive()
/* eslint-disable-next-line @angular-eslint/directive-class-suffix */
export abstract class AppBaseComponent extends BaseComponent {
  /**
   * Define common root app component behavior for all web apps here
   */
}
